import { Check, ChevronRight, Images } from "lucide-react";
import React, { useState } from "react";
import ToggleSwitch from "../settings/components/ToggleSwitch";

type Theme = {
  id: string;
  name: string;
};
type SelectThemeProps = {
  setIsThemeSelected: React.Dispatch<React.SetStateAction<boolean>>;
  options: Theme[];
  saveTheme: boolean;
};

export const SelectTheme: React.FC<SelectThemeProps> = ({
  setIsThemeSelected,
  options,
  saveTheme = true,
}) => {
  const [selectedIdx, setSelectedIdx] = useState<number | null>(null);
  const handleThemeSelect = (themeId: string) => {
    setIsThemeSelected(true);
    if (!saveTheme) {
      return;
    }
    localStorage.setItem("themeId", themeId);
  };

  return (
    <>
      <div className="select-component__duration-section">
        {options.map((theme: any) => {
          return (
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <button
                key={theme.id}
                className="strength-button select-component__duration-button two-part-button"
                style={{
                  display: "flex",
                  alignItems: "center",
                  flex: 1,
                  minWidth: 0,
                }}
                onClick={() => {
                  setSelectedIdx(theme.id);
                  handleThemeSelect(theme.id);
                }}
              >
                <span>{theme.name}</span>
              </button>
              {theme.id === selectedIdx && (
                <Check
                  className="w-4 h-4 text-red-500"
                  style={{ flexShrink: 0, marginRight: "12px" }}
                />
              )}
            </div>
          );
        })}
      </div>
    </>
  );
};
